import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/build/repo/src/components/default-layout-narrow.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`తరచుగా అడిగే ప్రశ్నలు`}</h1>
    <h3><a parentName="h3" {...{
        "href": "/faq"
      }}>{`English`}</a>{` | `}<a parentName="h3" {...{
        "href": "/lang/marathi/faq_marathi"
      }}>{`मराठी`}</a>{` | `}<a parentName="h3" {...{
        "href": "/lang/telugu/faq_telugu"
      }}>{`తెలుగు`}</a>{` | `}<a parentName="h3" {...{
        "href": "/lang/tamil/faq_tamil"
      }}>{`தமிழ்`}</a></h3>
    <h2>{`Tattle అంటే ఏమిటి?`}</h2>
    <p>{`Tattle అనేది, సరిచూసుకోబడిన సమాచారమును మొబైల్ ప్రథమ వినియోగదారులకు వారికి సౌకర్యవంతమైన భాషలో మరింత ప్రాప్యత కలిగించాలనే లక్ష్యముతో ఇండియా నుండి ఉద్భవించిన ఒక పౌర సాంకేతిక పథకము.వాట్సాప్ పై తప్పుడు సమాచారమును పరిష్కరించే ఉద్దేశ్యముతో ప్రారంభమై, ఈ పథకము చాట్ యాప్స్ మరియు సాధారణంగా ఎన్‌క్రిప్ట్ చేయబడిన నెట్‌వర్క్ లపై తప్పుడు సమాచారమును పరిష్కరించే దిశగా విస్తరించింది.
Tattle యొక్క లక్ష్యాలు ఏవేవి?
రాబోవు కాలములో Tattle ఇలా చేయగలుగుతుందని మేము భావిస్తున్నాము:`}</p>
    <ul>
      <li parentName="ul">{`వాట్సాప్ మరియు ఇతర చాట్ యాప్స్ పై తప్పుడు సమాచారము యొక్క జీవితచక్రమును తగ్గించుటకు సహాయపడుతుంది.`}</li>
      <li parentName="ul">{`సామాజిక మాధ్యమముపై, ప్రత్యేకించి ఎన్‌క్రిప్ట్ చేయబడిన నెట్‌వర్క్ లపై తప్పుడు సమాచారముపై స్వేచ్ఛాయుత మరియు పారదర్శక పరిశోధనకు వీలు కల్పిస్తుంది.`}</li>
    </ul>
    <h2>{`Tattle తన విజయాలను ఎలా కొలుస్తుంది?`}</h2>
    <ul>
      <li parentName="ul">{`నిజ పరిశీలన/పరిశోధనకు సహాయపడేందుకై మేము బహిరంగ మూల సాధనాల యొక్క ఒక రిపోజిటరీని అభివృద్ధి చేస్తున్నాము. సాధనాల యొక్క పనితీరు ప్రాథమిక రేఖ (ఒకవేళ ఉంటే) మీదుగా మెరుగుదలలపై విశ్లేషించబడుతుంది.`}</li>
      <li parentName="ul">{`పౌరులు మరియు నిజనిర్ధారణ సమూహాలు దీని సాధనాలను అలవరచుకోవడం ద్వారా.`}</li>
      <li parentName="ul">{`ఇండియాలో సామాజిక మాధ్యమంపై తప్పు సమాచారం/ సమాచారలోపం పట్ల కొత్త పరిజ్ఞానమును కల్పించడం ద్వారా.`}</li>
    </ul>
    <h2>{`Tattle యొక్క విలువలు ఏవేవి?`}</h2>
    <ul>
      <li parentName="ul">{`నిష్కాపట్యము`}</li>
      <li parentName="ul">{`ప్రాప్యత`}</li>
      <li parentName="ul">{`సుస్థిరత`}</li>
      <li parentName="ul">{`నమ్రత`}</li>
      <li parentName="ul">{`ఉత్సుకత
ఈ విలువల పట్ల మా చేరువ విధానము గురించి మీరు ఇక్కడ మరింతగా చదువుకోవచ్చు.`}</li>
    </ul>
    <h2>{`Tattle యొక్క పని ఎలా లైసెన్స్ పొందుతుంది?`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gnu.org/licenses/gpl-3.0.en.html"
        }}>{`GPL`}</a>{` క్రింద కోడ్ విడుదల చేయబడింది.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://opendatacommons.org/licenses/odbl/"
        }}>{`ODbL`}</a>{` క్రింద తేదీ విడుదల చేయబడింది.`}</li>
    </ul>
    <h2>{`Tattle యొక్క సంస్థాగత నిర్మాణము ఏది?`}</h2>
    <p>{`Tattle అనేది ఇండియాలో ఒక ప్రైవేట్ లిమిటెడ్ కంపెనీగా రిజిస్టర్ చేయబడింది. ప్రధానంగా సమ్మతివహింపు (కాంప్లియెన్స్) పద్దులను తగ్గించడానికి మేము ఒక ప్రైవేట్ లిమిటెడ్ కంపెనీగా రిజిస్టర్ చేసుకున్నాము. మేము ఆర్థికపరంగా `}<a parentName="p" {...{
        "href": "https://aiethicsinitiative.org/news/2019/3/12/announcing-the-winners-of-the-ai-and-the-news-open-challenge"
      }}>{`AI ఎథిక్స్ ఇనిషియేటివ్`}</a>{` నుండి తోడ్పాటు అందించబడి ఉన్నాము.
డెన్నీ మరియు తరుణిమ ఈ ప్రాజెక్టు యొక్క దీర్ఘకాలిక సంరక్షకులుగా ఉన్నారు.ఇప్పటి వరకూ ఈ పథకము స్వచ్ఛందకార్యకర్తలు, బహిరంగ మూలపు దాతలు మరియు స్వల్పకాలిక సిబ్బందిచే తోడ్పాటు ఇవ్వబడుతూ వస్తోంది.ఈ పథకములో మరింత మందిని నిమగ్నం చేయడానికి మా బృందము ఎల్లప్పుడూ ఎదురు చూస్తోంది.
నేను ఎలా దోహదపడగలను?
అనంతమైన మార్గాలలో! ఒకవేళ మీరు ఒక నిబద్ధత కలిగిన పౌరులు, ఒక స్థానిక నిజ పరిశీలకులు, ఒక కళాకారులు, ఒక కథారచయిత, ఒక గ్రాఫిక్ డిజైనర్, ఒక ఇంజనీర్, ఒక టీచర్....ప్రధానంగా ఆన్‌లైన్ సంభాషణల ఆరోగ్యాన్ని మెరుగుపరచాలని కోరుకునే ఏ వ్యక్తి అయినా, మీతో సమన్వయం చేసుకోవడానికి మేము ఎంతగానో ఇష్టపడతాము. సంప్రదింపు పేజీకి వెళ్ళండి మరియు మాకు ఒక పంక్తి వ్రాయండి.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      